var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"color":"primary","to":"/"}},[_vm._v(_vm._s(_vm.$t("home")))])
}
var staticRenderFns = []

export { render, staticRenderFns }